export default {
  draw: function draw(context, size) {
    var w = Math.sqrt(size),
      x = -w / 2;
    context.rect(x, x, w, w);
  }
};